module.exports = __webpack_public_path__ + "img/adress.a17e15bb.jpg";